module.exports = __webpack_public_path__ + "img/meta.cce9d561.svg";